import { Route } from 'react-router-dom';
import PageTemplates from '../../pages/raptor/cpd/templates/templates.page';
import PageOperators from '../../pages/raptor/cpd/operators/operators.page';
import PageRoutes from '../../pages/raptor/cpd/routes/routes.page';
import PageOverrides from '../../pages/raptor/cpd/overrides/overrides.page';

export const RaptorCPDRoutes = (
  <>
    <Route path="/cpd-templates">
      <Route index element={<PageTemplates />} />
    </Route>
    <Route path="/cpd-templates">
      <Route index element={<PageTemplates />} />
    </Route>
    <Route path="/cpd-operators">
      <Route index element={<PageOperators />} />
    </Route>
    <Route path="/cpd-routes">
      <Route index element={<PageRoutes />} />
    </Route>
    <Route path="/cpd-overrides">
      <Route index element={<PageOverrides />} />
    </Route>
  </>
);
